export default __webpack_public_path__ + "static/media/logo_tagline.07cf06a6.png";